(function () {
/*
 * -----------------------------------------------------------------------------
 * @cam/product-price
 * -----------------------------------------------------------------------------
 * @version 0.0.3
 * @overview Dynamic variant prices.
 * @copyright 2021 Cam Gould & Elkfox Co Pty Ltd - All rights reserved
 * -----------------------------------------------------------------------------
 * @requires @cam/product-form
 * -----------------------------------------------------------------------------
*/ if (customElements.get("product-price") === undefined) {
    class ProductPrice extends HTMLElement {
        constructor(){
            super();
            if (!this.dataset.productForm || !this.dataset.url || !this.dataset.section) return;
            document.querySelector(`#${this.dataset.productForm}`)?.closest("product-form")?.idInput.addEventListener("change", this.changeEvent.bind(this));
        }
        changeEvent(event) {
            !event.target.value ? this.variantUnavailable() : this.variantUpdated(event);
        }
        variantUnavailable() {
            this.setAttribute("hidden", "");
        }
        variantUpdated(event) {
            fetch(`${this.dataset.url}?variant=${event.target.value}&section_id=${this.dataset.section}`).then((response)=>response.text()).then((responseText)=>{
                let html = new DOMParser().parseFromString(responseText, "text/html");
                this.innerHTML = html.querySelector(this.nodeName).innerHTML;
                this.removeAttribute("hidden");
            });
        }
    }
    customElements.define("product-price", ProductPrice);
}



})();
